import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from 'classnames';
import { useCallback, useMemo, useRef, useState, } from 'react';
import { isDark } from '..';
import styles from './read-more.module.scss';
const ReadMore = ({ children, RTL, size = 'sm', linesToShow = 4, readMoreText = 'Read more', showLessText = 'Show less', position = 'right', }) => {
    const ref = useRef(null);
    const [lineHeight, setLineHeight] = useState(0);
    const [totalHeight, setTotalHeight] = useState(0);
    const [showMore, setShowMore] = useState(false);
    const isDarkMode = useMemo(() => isDark(), []);
    const containerClass = useMemo(() => cx(styles.container, styles[position], RTL ? styles.rtl : ''), [RTL]);
    const readMoreClass = useMemo(() => cx(styles.wrapper, styles[size], RTL ? styles.rtl : '', isDarkMode ? styles.dark : ''), [isDarkMode]);
    const buttonClass = useMemo(() => cx(styles.button, isDarkMode ? styles.dark : '', styles[size], styles[position]), [isDarkMode]);
    const onRef = useCallback((node) => {
        if (node) {
            ref.current = node;
            const { lineHeight, height } = window.getComputedStyle(node);
            setLineHeight(Math.round(+lineHeight.replace('px', '') * linesToShow));
            setTotalHeight(Math.round(+height.replace('px', '')));
        }
    }, []);
    const toggleShowMore = useCallback(() => {
        setShowMore(!showMore);
    }, [showMore]);
    const contentHeight = useMemo(() => {
        if (!totalHeight && !lineHeight) {
            return;
        }
        if (showMore) {
            return totalHeight;
        }
        else {
            return lineHeight;
        }
    }, [showMore, lineHeight, totalHeight]);
    const style = useMemo(() => {
        return { height: contentHeight ? `${contentHeight}px` : 'auto' };
    }, [contentHeight]);
    return (_jsxs("div", { className: containerClass, children: [_jsx("p", { ref: onRef, className: readMoreClass, style: style, children: children }), _jsx("button", { onClick: toggleShowMore, className: buttonClass, children: showMore ? showLessText : readMoreText })] }));
};
ReadMore.displayName = 'ReadMore';
export { ReadMore };
